module.exports = "https://cdn.prod.zoopla.co.uk/_next/static/images/sold-property-cluster-pin-2fdb08bfc6cf9975878696c7da3f4c3a.svg";